import axios from 'axios';
import Vue from 'vue'

export default {
    getMessages(page, pageSize,userId){
        return axios.get('/api/chat/get', { params: {page: page, pageSize: pageSize,userId:userId} })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    sendMessage(message,userId){
        return axios.post('/api/chat/send', {message:message,userId:userId} )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    changeStatus(userId){
        return axios.post('/api/chat/changeStatus', {userId:userId} )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }
}